import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Container } from 'reactstrap';

import Page from '../../components/Layout/Page/Page';
import Loader from '../../components/Common/Loader';
import UserRow from '../../components/Users/UserRow/UserRow';

import { loadArtists } from '../../helpers/api/users.api';

import '../Tracks/Tracks.scss';

const AdminArtists = props => {
    const [loading, setLoading] = useState(true);
    const [artists, setArtists] = useState([]);

    useEffect(() => {
        setLoading(true);
        loadArtists()
            .then((result) => {
                if (result.success) {
                    setArtists(result.users);
                } else {
                    setArtists([]);
                }
                setLoading(false);
            })
            .catch((error) => {
                setArtists([]);
                setLoading(false);
                console.log(error);
            });
    }, []);

    return <Page className="tracks">
        <Container fluid className="h-100 d-flex flex-column">
            {loading ?
                <Loader />
                : artists ? <Row className="h-50 pt-3">
                    <Col className="h-100">
                        <ul className="users-list h-100">
                            {artists.map(u => <UserRow key={u._id} user={u} />)}
                        </ul>
                    </Col>
                </Row> : null}
        </Container>
    </Page>;
}

const mapStatetoProps = (state) => {
    return { user: state.Auth.user };
};

export default connect(mapStatetoProps, {})(AdminArtists);